import { render, staticRenderFns } from "./import-excel-model.vue?vue&type=template&id=2437a554&scoped=true"
import script from "./import-excel-model.vue?vue&type=script&lang=js"
export * from "./import-excel-model.vue?vue&type=script&lang=js"
import style0 from "./import-excel-model.vue?vue&type=style&index=0&id=2437a554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437a554",
  null
  
)

export default component.exports